import { useCancelInvitationMutation } from '@/api/api.slice.tsx';
import { useAppSelector } from '@/app/hooks.ts';
import {
  closeDialogCancelInvite,
  getAccountsState,
} from '@/features/accounts/accounts.slice.ts';
import { Button, Dialog, Typography } from '@arsnovasystems/ars-front-lib';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

/**
 * The dialog to explain the cancellation limitation and to trigger it.
 *
 * @returns The CancelInvitationAlert component
 */
export const CancelInvitationAlert = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { dialogCancelInviteOpen, invitationToCancel } =
    useAppSelector(getAccountsState);
  const [cancelInvitation, { isLoading: cancelInviteUserIsLoading }] =
    useCancelInvitationMutation();

  const cancelInviteUserHandler = async () => {
    if (!invitationToCancel) {
      throw new Error('No invitation to cancel');
    }

    const { error } = await cancelInvitation(invitationToCancel.id);
    if (!error) {
      dispatch(closeDialogCancelInvite());
    }
  };

  return (
    <Dialog
      open={dialogCancelInviteOpen}
      title={t('ik.customerAccounts.cancelInvitation.title')}
      actions={[
        <Button
          onClick={() => {
            dispatch(closeDialogCancelInvite());
          }}
        >
          {t('ik.cancel')}
        </Button>,
        <Button
          loading={cancelInviteUserIsLoading}
          type='submit'
          onClick={cancelInviteUserHandler}
        >
          {t('ik.confirm')}
        </Button>,
      ]}
    >
      <Typography>
        {t('ik.customerAccounts.cancelInvitation.description')}
      </Typography>
      <Typography>
        {t('ik.customerAccounts.cancelInvitation.confirmHint')}
      </Typography>
    </Dialog>
  );
};
